import { DialogModal, RadioGroup, Typography } from "@ecologi/react-components";
import styled from "@emotion/styled";

export enum RemovalReasonId {
  NOT_RIGHT_PRODUCT = "not_right_product",
  TOO_EXPENSIVE = "too_expensive",
  WRONG_QUANTITY = "wrong_quantity",
  WRONG_FUNDED_BY = "wrong_funded_by",
  BUY_LATER = "buy_later",
  NO_REASON_GIVEN = "no_reason_given",
}

const REMOVAL_REASONS: Array<{ label: string; value: RemovalReasonId }> = [
  { label: "Not the right product", value: RemovalReasonId.NOT_RIGHT_PRODUCT },
  { label: "Too expensive", value: RemovalReasonId.TOO_EXPENSIVE },
  { label: "Wrong quantity", value: RemovalReasonId.WRONG_QUANTITY },
  { label: "Wrong 'funded by'", value: RemovalReasonId.WRONG_FUNDED_BY },
  { label: "I'll buy this another time", value: RemovalReasonId.BUY_LATER },
];

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 60px 24px 24px 24px;
  gap: 10px;
`;

const Modal = styled(DialogModal)`
  max-width: 500px;
`;

const StyledRadioGroup = styled(RadioGroup)`
  margin-top: 24px;
  margin-bottom: 18px;
`;

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onReasonSelected: (reason: RemovalReasonId) => void;
  selectedReason: RemovalReasonId | "";
  onReasonChange: (reason: RemovalReasonId) => void;
}

export const RemovalReasonModal = ({
  isOpen,
  onClose,
  onReasonSelected,
  selectedReason,
  onReasonChange,
}: Props) => {
  const handleReasonChange = (value: RemovalReasonId) => {
    onReasonChange(value);
    onReasonSelected(value);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      dataTestId="removal-reason-modal"
      inline
    >
      <ContentContainer>
        <Typography use="componentTitle">Your feedback matters.</Typography>
        <Typography use="body1">
          Why do you no longer want to purchase this product?
        </Typography>
        <StyledRadioGroup
          items={REMOVAL_REASONS}
          value={selectedReason}
          onValueChange={handleReasonChange}
          ariaLabel="Reason for removing product"
          id="removal-reason-radio-group"
        />
      </ContentContainer>
    </Modal>
  );
};
